/** Nullable string fields that should be sent as `null` when cleared (empty/whitespace). */
export const NULLABLE_STRING_FIELDS = ['tresorId', 'legalName'];

/** Matches garage API / DB `tresor_id VARCHAR(32)`. */
export const TRESOR_ID_MAX_LENGTH = 32;

/**
 * @param {Record<string, any>} values
 * @returns {Record<string, any>}
 */
export function normalizeOptionalStrings(values) {
  const normalized = { ...values };
  NULLABLE_STRING_FIELDS.forEach((field) => {
    if (typeof normalized[field] !== 'string') {
      return;
    }
    const trimmed = normalized[field].trim();
    normalized[field] = trimmed === '' ? null : trimmed;
  });
  return normalized;
}
